import { Capacitor } from '@capacitor/core';
import log from './log';

const baseUrl = Capacitor.isNativePlatform() ? 'https://www.cryptowaves.app/api' : '/api';
const usersUrl = Capacitor.isNativePlatform() ? 'https://www.cryptowaves.app/api/users' : '/api/users';

const getAuthHeaders = () => {
    const authToken = localStorage.getItem('token');
    return {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + authToken,
    }
}

const getHeaders = () => {
  return {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
  }
}

const toJson = (result) => {
    try{
      return result.then(data => data.json()).then((data) => data)
    } catch(err){
      return {}
    }
}

const Fetcher = {
  signInUser: (name, email, avatarUrl) => {
      return toJson(fetch(`${baseUrl}/users/login`, {
          method: 'post',
          headers: {'Content-Type':'application/json'},
          body: JSON.stringify({
            name: name,
            email: email,
            avatarUrl: avatarUrl
          })}))
  },
  authAppleUser: (data) => {
    return toJson(fetch(`${baseUrl}/users/auth/apple`, {
        method: 'post',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify(
          data
        )}))
},
  refreshToken: (name, email) => {
    return toJson(fetch(`${baseUrl}/users/login`, {
        method: 'post',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
          name: name,
          email: email
        })}))
  },

  getRSI: () => {
    return toJson(fetch(`${baseUrl}/rsi`, {
      headers: getHeaders()
    }))
  },

  getIndicators: () => {
    return toJson(fetch(`${baseUrl}/indicators`, {
      headers: getHeaders()
    }))
  },

  getSignals: () => {
    return toJson(fetch(`${baseUrl}/signals`, {
      headers: getHeaders()
    }))
  },

  getAlertsHistory: (coin) => {
    return toJson(fetch(`${baseUrl}/signals/history/${coin}`, {
      headers: getHeaders()
    }))
  },

  getCoinDetails: (coin) => {
    return toJson(fetch(`${baseUrl}/rsi/${coin}`, {
      headers: getHeaders()
    }))
  },

  getPortfolio: () => {
    return toJson(fetch(`${usersUrl}/portfolio`, {
      headers: getAuthHeaders()
    }))
  },

  addToPortfolio: (coin) => {
    return toJson(fetch(`${usersUrl}/portfolio/add/${coin}`, {
      headers: getAuthHeaders()
    }))
  },

  updateAlertSettings: (alertSettings) => {
    log.traceTag('updateAlertSettings', alertSettings )
    return toJson(fetch(`${usersUrl}/settings`,{
      method: 'post',
      headers: getAuthHeaders(),
      body: JSON.stringify(alertSettings)
    }))
  },

  removeFromPortfolio: (coin) => {
    return toJson(fetch(`${usersUrl}/portfolio/remove/${coin}`, {
      headers: getAuthHeaders()
    }))
  },

  // STRIPE

  getPlans: () => {
    return toJson(fetch(`${baseUrl}/plans`, {
      headers: getHeaders()
    }))
  },

  createCheckoutSession: (plan) => {

    log.trace('createCheckoutSession');
    log.trace(plan);

    // 🏷️ Retrieve campaign and referral IDs using SoycapTracker
    //const campaignId = typeof window !== 'undefined' ? window.SoycapTracker.getCampaignId() : null;
    //const referralId = typeof window !== 'undefined' ? window.SoycapTracker.getReferralId() : null;

    // 🕒 Validate expiration (SoycapTracker already handles TTL internally)
    //const isValidReferral = campaignId && referralId;
    
    //if (isValidReferral) {
    //  plan.plan.soycap_campaignId = campaignId;
    //  plan.plan.soycap_referralId = referralId;
    //}
    
    return toJson(fetch(`${baseUrl}/users/create-checkout-session`,{
      method: 'post',
      headers: getAuthHeaders(),
      body: JSON.stringify(plan)
    }))
  },
  redirectToCustomerPortal: () => {
    log.traceTag('redirectToCustomerPortal')
    return toJson(fetch(`${baseUrl}/users/customer-portal`,{
      method: 'post',
      headers: getAuthHeaders()
    }))
  },
  getBlogPosts: () => {
    return toJson(fetch(`${baseUrl}/blog`))
  },
  getBlogPost: (url) =>{
    return toJson(fetch(`${baseUrl}${url}`))
  },
  getSOLRateInCurrency: () => {
    return toJson(fetch(`${baseUrl}/rsi/SOL`, {
      headers: getHeaders()
    }));
  },
  getETHRateInCurrency: (curr) => {
    return toJson(fetch(`${baseUrl}/rsi/ETH`, {
      headers: getHeaders()
    }))
  },
  unlockWithCrypto: (coin, receipt, monthsCrypto) => {
    return toJson(fetch(`${baseUrl}/users/unlock/crypto`,{
      method: 'post',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        coin: coin,
        receipt: receipt, // { amount, txn }
        months: monthsCrypto
      })
    }))
  },
  unlockWithAndroid: (customer_email, planCode) => {
    return toJson(fetch(`${baseUrl}/users/unlock/android`,{
      method: 'post',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        customer_email: customer_email,
        planCode: planCode
      })
    }))
  },
  unlockWithIOS: (customer_email, planCode, customerId, originalTransactionId) => {
    return toJson(fetch(`${baseUrl}/users/unlock/ios`,{
      method: 'post',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        customer_email: customer_email,
        planCode: planCode
      })
    }))
  },
  getRandomProUser: () => {
    return toJson(fetch(`${baseUrl}/users/randompro`, {
      headers: getHeaders()
    }))
  },
  getCoinInfo: (coin) => {
    return toJson(fetch(`${baseUrl}/rsi/info/${coin}`, {
      headers: getHeaders()
    }))
  }
}

export default Fetcher;